import React from "react";
import Axios from "axios";
import {
  GET_ORDER,
  GET_ORDERS_AMOUNT,
  GET_ORDERS,
  LOADING_ORDERS,
  LOADING_ORDER,
  UPDATE_ORDER,
  CLEAR_ERRORS,
  GET_ERRORS,
  CREATE_SMS_ITEM,
  POST_ORDER_SHIPPING,
  CREATE_ORDER_STATUS,
  UPDATE_SERIAL_NUMBER,
  POST_TO_RIVILE,
  UPDATE_SERIAL_NUMBER_STATE,
  UPDATE_ORDER_SOCKETS,
  ORDER_CREATE_INVOICE,
  POST_ORDER_ROW_GOODS,
  UPDATE_ORDER_ROW_GOODS,
  DELETE_ORDER_ROW_GOODS,
  UPDATE_CART_RULES,
  UPDATE_SUPPLYING,
  SET_COD_SELECTED,
  SET_GLOBAL_MODAL,
  GET_ORDERS_SHIPMENTS_OVER_80_KG,
} from "./types";
import { logoutUser } from "./authAction";
import { message } from "antd";
import { successToast, unsuccessToast } from "../../helpers/ErrorsToasts";
import { orderInvoiceUpdateStatus } from "./order_invoice_action";
import { antdMessageError, antdMessageSuccess } from "../../helpers/Utils";
import {
  antdAsyncMessageError,
  antdAsyncMessageLoading,
  antdAsyncMessageSuccess,
} from "../../helpers/AsyncMessage";
import AntdConfirm from "../../helpers/AntdConfirm";
import { validCreatingShipment } from "../../helpers/ShipmentRules";
import {
  setCountriesOptions,
  setOrderShopsOptions,
  setPickupAddressesOptions,
} from "./options_action";
import { setUserSuppliers } from "./filtersAction";

const token = document.querySelector('meta[name="csrf-token"]').content;
Axios.defaults.headers.common["X-CSRF-Token"] = token;

const orderMainSuccess = () => {
  if (!document.getElementById("order-s")) return;
  document.getElementById("order-s").style.display = "block";
  setTimeout(
    () => (document.getElementById("order-s").style.display = "none"),
    5000,
  );
};

const orderMainError = () => {
  if (!document.getElementById("order-e")) return;
  document.getElementById("order-e").style.display = "block";
  setTimeout(
    () => (document.getElementById("order-e").style.display = "none"),
    5000,
  );
};

const errorOrder = () => {
  if (!document.getElementById("order-e")) return;
  document.getElementById("order-e").style.display = "block";
  setTimeout(
    () => (document.getElementById("order-e").style.display = "none"),
    5000,
  );
};

export const setOrderSettings = (obj) => (dispatch, getState) => {
  const state = getState();
  let { settings } = state.orders;
  let settings_obj = {
    ...settings,
    ...obj,
  };
  dispatch({
    type: "SET_SETTINGS",
    payload: settings_obj,
  });
  if (obj["total_amount"]) {
    dispatch(getOrdersAmount());
  }
  if (obj["params_filter"] || obj["page_count"] || obj["page"]) {
    dispatch(getOrders());
  }
};

// Nordrent variant of setOrderSettings: routes total_amount + list refetch
// (pagination / page size / filters) through the nordrent-namespaced endpoints.
export const setNordrentOrderSettings = (obj) => (dispatch, getState) => {
  const state = getState();
  let { settings } = state.orders;
  let settings_obj = {
    ...settings,
    ...obj,
  };
  dispatch({
    type: "SET_SETTINGS",
    payload: settings_obj,
  });
  if (obj["total_amount"]) {
    dispatch(getNordrentOrdersAmount());
  }
  if (obj["params_filter"] || obj["page_count"] || obj["page"]) {
    dispatch(getNordrentOrders());
  }
};

const getOrdersAmount = () => (dispatch, getState) => {
  const state = getState();
  let { settings } = state.orders;
  // if (!settings.total_amount) return;
  dispatch({
    type: GET_ORDERS_AMOUNT,
    payload: {
      total_amount: "loading",
      total_urgent: "loading",
      total_vip: "loading",
    },
  });
  Axios.get(
    `/api/v1/orders/total_amount?page=${settings.page}&per_page=${settings.page_count}&amount=${settings.total_amount}${settings.params_filter}`,
  ).then((response) => {
    dispatch({
      type: GET_ORDERS_AMOUNT,
      payload: response.data,
    });
  });
};

// Nordrent variant of getOrdersAmount: hits the nordrent-namespaced total_amount route.
const getNordrentOrdersAmount = () => (dispatch, getState) => {
  const state = getState();
  let { settings } = state.orders;
  dispatch({
    type: GET_ORDERS_AMOUNT,
    payload: {
      total_amount: "loading",
      total_urgent: "loading",
    },
  });
  Axios.get(
    `/api/v1/nordrent/orders/total_amount?page=${settings.page}&per_page=${settings.page_count}&amount=${settings.total_amount}${settings.params_filter}`,
  ).then((response) => {
    dispatch({
      type: GET_ORDERS_AMOUNT,
      payload: response.data,
    });
  });
};

export const setCodSelected = (isSelected) => ({
  type: SET_COD_SELECTED,
  payload: isSelected,
});

export const setGlobalModal = (isOpen, numbersArray, modalName) => ({
  type: SET_GLOBAL_MODAL,
  payload: {
    isOpen,
    numbersArray,
    modalName,
  },
});

export const createInvoices = async (
  action,
  stateChecked,
  order_row_ids,
  stateParams,
) => {
  let url =
    action == "selected"
      ? "/api/v1/orders/create_invoices/"
      : `/api/v1/orders/create_invoices?${stateParams}`;
  let checked = action == "selected" ? stateChecked : [];
  try {
    await Axios.post(url, {
      checked: checked,
      order_row_ids: action == "selected" ? order_row_ids : [],
    });
    orderMainSuccess();
  } catch (e) {
    orderMainError();
    if (e?.response?.data) {
      e.response.data.errors;
      if (e?.response?.data?.error) {
        e?.response?.data?.error.forEach((e, idx) =>
          message.error({
            key: `message_${idx}`,
            content: e,
            duration: 0,
            className: "cursor-pointer",
            onClick: () => message.destroy(`message_${idx}`),
          }),
        );
      }
    }
  }
};

export const updateOrderSockets = (response) => (dispatch) => {
  dispatch({
    type: UPDATE_ORDER_SOCKETS,
    payload: response,
  });
};

export const getOrders = () => (dispatch, getState) => {
  dispatch({
    type: GET_ORDERS_AMOUNT,
    payload: {
      total_amount: "loading",
      total_urgent: "loading",
      total_vip: "loading",
      total_shipments_with_error: "loading",
      total_invoices_with_error: "loading",
    },
  });
  dispatch(setOrderLoading());
  const state = getState();
  let { settings } = state.orders;

  return Axios.get(
    `/api/v1/orders?page=${settings.page}&per_page=${settings.page_count}${settings.params_filter}`,
  )
    .then((res) => {
      if (res.data == undefined || Object.keys(res.data).length === 0) {
        return dispatch(logoutUser());
      }
      dispatch({
        type: GET_ORDERS,
        payload: res.data,
      });
      dispatch(getOrdersAmount());
      if (res.data.data.length > 0) {
        return true;
      }
    })
    .catch((err) => {
      console.log({ err });
      antdMessageError();
      if (err?.response?.data?.hasOwnProperty("error")) {
        dispatch(logoutUser());
      } else if (err?.response?.data) {
        dispatch({
          type: GET_ERRORS,
          payload: err?.response?.data || {},
        });
      }
    })
    .finally(() => {
      getUserSuppliers(dispatch);
    });
};

export const getNordrentOrders = () => (dispatch, getState) => {
  dispatch({
    type: GET_ORDERS_AMOUNT,
    payload: {
      total_amount: "loading",
      total_urgent: "loading",
      total_shipments_with_error: "loading",
      total_invoices_with_error: "loading",
    },
  });
  dispatch(setOrderLoading());
  const state = getState();
  let { settings } = state.orders;

  return Axios.get(
    `/api/v1/nordrent/orders?page=${settings.page}&per_page=${settings.page_count}${settings.params_filter}`,
  )
    .then((res) => {
      if (res.data == undefined || Object.keys(res.data).length === 0) {
        return dispatch(logoutUser());
      }
      dispatch({
        type: GET_ORDERS,
        payload: res.data,
      });
      dispatch(getNordrentOrdersAmount());
      if (res.data.data.length > 0) {
        return true;
      }
    })
    .catch((err) => {
      console.log({ err });
      antdMessageError();
      if (err?.response?.data?.hasOwnProperty("error")) {
        dispatch(logoutUser());
      } else if (err?.response?.data) {
        dispatch({
          type: GET_ERRORS,
          payload: err?.response?.data || {},
        });
      }
    })
    .finally(() => {
      getUserSuppliers(dispatch);
    });
};

export const getUserSuppliers = async (dispatch) => {
  const { data } = await Axios.get("/api/v1/user_suppliers_favorites");
  if (data) {
    dispatch(setUserSuppliers(data?.map((item) => item.filters)?.flat()));
  }
};

export const localStorageShipmentBulkSetter =
  (order_id, values, old_pickup_address_id) => async (dispatch, getState) => {
    try {
      let bulk_shipments = getState().orders.bulk_shipments;

      if (!bulk_shipments[order_id]) bulk_shipments[order_id] = [];
      if (!!bulk_shipments[order_id].length) {
        const find_index = bulk_shipments[order_id].findIndex(
          (d) =>
            d.pickup_address_id ==
            (old_pickup_address_id == "ignore"
              ? values.pickup_address_id
              : old_pickup_address_id),
        );

        if (find_index == -1) bulk_shipments[order_id].push(values);
        else bulk_shipments[order_id][find_index] = values;
      } else {
        bulk_shipments[order_id] = [values];
      }

      dispatch({
        type: "UPDATE_BULK_SHIPMENTS",
        payload: bulk_shipments,
      });
    } catch (err) {
      console.log("ERROR: ", err);
    }
  };

// TODO: Dead method
export const orderCreateInvoice = (id) => (dispatch) => {
  return Axios.post(`/api/v1/orders/${id}/create_invoice`).then((response) => {
    if (response.data) {
      if (response.data.invoice_number) {
        dispatch({
          type: ORDER_CREATE_INVOICE,
          payload: { invoice_number: response.data.invoice_number, id },
        });
        return {
          error: null,
          loading: false,
        };
      }
      if (response.data.errors) {
        errorOrder();
        return {
          error: response.data.errors,
          loading: false,
        };
      }
      return { code: null, error: null, loading: false };
    }
  });
};

export const createBulkReturns = (ids) => (dispatch) => {
  return Axios.post(`/api/v1/order_returns/bulk_create`, {
    order_returns: ids,
  }).then((response) => {
    if (response.data) {
      return { code: null, error: null, loading: false };
    }
  });
};

export const createPartialInvoice =
  (id, params = {}, protector = true) =>
  async (dispatch) => {
    try {
      const { data } = await Axios.post(
        `/api/v1/orders/${id}/create_partial_invoice`,
        (params = {
          ...params,
          protector,
        }),
      );
      if (data) {
        if (data.invoices?.length > 0) {
          dispatch({
            type: "ORDER_INVOICES",
            payload: data,
          });
          antdMessageSuccess();
          dispatch(orderInvoiceUpdateStatus(id));
          return { code: null, error: null, loading: false };
        } else {
          antdMessageError();
        }
        if (data.invoice_number) {
          dispatch({
            type: ORDER_CREATE_INVOICE,
            payload: { invoice_number: data.invoice_number, id },
          });
          return {
            error: null,
            loading: false,
            invoice_number: data.invoice_number,
          };
        }
        if (data.errors) {
          antdMessageError(JSON.stringify(data.errors));
          if (data.type == "protector") {
            return AntdConfirm({
              content: (
                <span
                  dangerouslySetInnerHTML={{
                    __html: data.message || "Something wrong",
                  }}
                />
              ),
              onOk: () => {
                dispatch(createPartialInvoice(id, params, false));
              },
            });
          }
          return {
            error: data.errors,
            loading: false,
          };
        }
        return { code: null, error: null, loading: false };
      }
    } catch (err) {
      antdMessageError();
      console.log(err.response.data);
      if (err?.response?.data) {
        return { code: null, error: err?.response?.data[0], loading: false };
      }
      return { code: null, error: null, loading: false };
    }
  };

export const updateOrderAddress = (id, params) => (dispatch, getState) => {
  const order = getState().orders.order;

  let variables = {
    order: {
      ...params,
    },
  };

  if (variables.order?.customer_attributes) {
    const { firstname, lastname, other } =
      variables.order.billing_address_attributes || {};

    variables.order.customer_attributes = {
      ...order.customer,
      ...variables.order.customer_attributes,
      firstname: firstname || order.customer.firstname,
      lastname: lastname || order.customer.lastname,
      email: other || order.customer.email,
    };

    variables.order.billing_address_attributes = {
      ...order.billing_address,
      ...variables.order.billing_address_attributes,
    };
    delete variables.order.billing_address_attributes.country;
  }

  return Axios.put(`/api/v1/orders/${id}`, variables)
    .then((res) => {
      dispatch({
        type: UPDATE_ORDER,
        payload: res.data,
      });
      return { ok: true, data: res.data };
    })
    .catch((err) => {
      if (err?.response && err?.response?.data && err?.response?.data?.error) {
        return { ok: false, error: err?.response?.data?.error };
      }
      return { ok: false };
    });
};

export const updateOrder = (id, params) => (dispatch) => {
  const variables = {
    order: {
      ...params,
    },
  };
  return Axios.put(`/api/v1/orders/${id}`, variables)
    .then((res) => {
      dispatch({
        type: UPDATE_ORDER,
        payload: {
          id: id,
          ...params,
        },
        // payload: res.data,
      });
      return { ok: true, data: res.data };
    })
    .catch((err) => {
      return { ok: false };
    });
};

export const postOrderShipping =
  (id, orderBody, form_type) => async (dispatch) => {
    const key = "postOrderShipping";
    //
    let params = orderBody;
    if (params.shipment.pickup_address_id == 264) {
      params.shipment.shipment_order_rows_attributes = [];
    }
    //
    try {
      const { isValid } = validCreatingShipment(
        orderBody.shipment,
        orderBody?.id_order,
      );
      if (!isValid) {
        return { success: false, errors: [] };
      }
      // antdAsyncMessageLoading({ key });

      // cia
      let api_url = `/api/v1/orders/${id}/shipments`;
      if (form_type == "FakeOrder") {
        api_url = `/api/v1/fake_orders/${id}/create_shipment`;
      }
      if (form_type == "OrderReturn") {
        api_url = `/api/v1/order_returns/${id}/create_shipment`;
      }
      if (form_type == "ProductTransfer") {
        api_url = `/api/v1/product_transfers/${id}/create_shipment`;

        const { final_carrier, id_order, tr_request_item_ids, ...restParams } =
          params;

        params = {
          ...restParams,
        };
      }

      const { data } = await Axios.post(api_url, params);

      // Order redux - but NOT for ProductTransfer (different response format)
      if (!params.tr_request_item_id && form_type !== "ProductTransfer") {
        dispatch({
          type: POST_ORDER_SHIPPING,
          payload: data,
        });
      }

      // Handle different response formats and show appropriate messages
      if (form_type === "ProductTransfer") {
        // ProductTransfer returns { success: true, shipment_id: X }
        if (data?.success !== false) {
          antdAsyncMessageSuccess({
            key,
            text: "Successfully created shipment",
          });
        } else {
          antdAsyncMessageError({
            key,
            text: data?.error || `Failed to create shipment`,
          });
        }
      } else if (data?.shipment?.api_errors) {
        // Standard response with api_errors
        antdAsyncMessageError({
          key,
          text: `Api error: ${data.shipment.api_errors}`,
        });
      } else {
        // Standard successful response (Order, OrderReturn, FakeOrder)
        antdAsyncMessageSuccess({ key, text: "Successfully created shipment" });
      }

      if (form_type === "Order") {
        await dispatch(
          shipmentUpdateStatus({
            form_type,
            id,
            tr_request_item_id: params.tr_request_item_id,
          }),
        );
      }
      return {
        success: true,
        data,
      };
      // throw new Error("Err");
    } catch (err) {
      if (!(err?.message || "").includes("code 403")) {
        if (form_type === "Order") {
          await dispatch(
            shipmentUpdateStatus({
              form_type,
              id,
              tr_request_item_id: params.tr_request_item_id,
            }),
          );
        }
      }
      if (form_type !== "OrderReturn") {
        antdAsyncMessageError({ key, text: err?.response?.data?.message });
      }
      if (err?.response?.data) {
        dispatch({
          type: GET_ERRORS,
          payload: err?.response?.data || {},
        });
      }
      return { success: false, errors: err?.response?.data || [] };
    }
  };

const shipmentUpdateStatus =
  ({ form_type, id, tr_request_item_id }) =>
  async (dispatch) => {
    if (form_type === "Order") {
      // antdAsyncMessageLoading({
      //   key: "postOrderShipping",
      //   text: "Checking status for order",
      // });

      const { data: data_shipment } = await Axios.get(
        `/api/v1/orders/${id}/shipments/shipment_update_status`,
      );
      if (data_shipment?.success && !tr_request_item_id) {
        dispatch({
          type: CREATE_ORDER_STATUS,
          payload: data_shipment,
        });
      }
      antdAsyncMessageSuccess({
        key: "postOrderShipping",
        text: "Successfully checked order status",
      });
    }
  };
export const leasingRequest = (id, body) => (dispatch) => {
  return Axios.put(`/api/v1/orders/${id}`, body)
    .then((response) => {
      if (response.data) {
        dispatch({
          type: UPDATE_ORDER,
          payload: response.data,
        });
        return { success: true };
      } else {
        return { success: false };
      }
    })
    .catch((e) => {
      return { success: false };
    });
};

export const postToRivile = (ID) => (dispatch) => {
  return Axios.post(`/api/v1/orders/${ID}/rivile/register_address`)
    .then((response) => {
      dispatch({
        type: POST_TO_RIVILE,
        payload: { data: response.data, id: ID },
      });
      return { success: true };
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err?.response?.data || {},
      });
      return { success: false, error: err?.response?.data || {} };
    });
};

export const getOrder = (id) => async (dispatch) => {
  try {
    dispatch(setOrderShowLoading());
    const { data } = await Axios.get(`/api/v1/orders/${id}`);
    console.log({ data });
    if (!!data?.order?.carrier?.pickup_address_id) {
      await dispatch(setPickupAddressesOptions());
    }
    dispatch({
      type: GET_ORDER,
      payload: data,
      payload_id: id,
    });
  } catch (err) {
    dispatch({
      type: "SET_ORDER_ERROR",
      payload: JSON.stringify(err?.response?.data) || "Something went wrong",
    });
  }
};

// Nordrent variant of getOrder
export const getNordrentOrder = (id) => async (dispatch) => {
  try {
    dispatch(setOrderShowLoading());
    const { data } = await Axios.get(`/api/v1/nordrent/orders/${id}`);
    if (!!data?.order?.carrier?.pickup_address_id) {
      await dispatch(setPickupAddressesOptions());
    }
    dispatch({
      type: GET_ORDER,
      payload: {
        contracts: [],
        order_documents: [],
        payments: [],
        shipments: [],
        invoices: [],
        sms_sendings: [],
        money_refund_items: [],
        ...data,
        // Nordrent `show` omits per-row supplyings/supplying_incomes; default them so
        // OrderRowComponent/SupplyingTable don't read .length/.map of undefined.
        order_rows: (data?.order_rows || []).map((row) => ({
          supplyings: [],
          supplying_incomes: [],
          ...row,
        })),
      },
      payload_id: id,
    });
  } catch (err) {
    dispatch({
      type: "SET_ORDER_ERROR",
      payload: JSON.stringify(err?.response?.data) || "Something went wrong",
    });
  }
};

export const postOrderRowGoods = (body, orderId) => (dispatch) => {
  console.log({ body });
  return Axios.post(`/api/v1/orders/${orderId}/order_rows`, body)
    .then((res) => {
      if (res.data) {
        dispatch({
          type: POST_ORDER_ROW_GOODS,
          payload: { items: res.data.data, total_price: res.data.total_price },
        });
        // if (body.parent) {
        //   dispatch(
        //     postOrderRowGoods(
        //       { order_row: { ...body.parent, parent_id: res.data.data.id } },
        //       orderId
        //     )
        //   );
        // }
      }
      return { ok: true, id: res.data.data };
    })
    .catch((err) => {
      antdMessageError();
      return { ok: false };
    });
};

export const updateOrderRowGoods =
  (body, orderId, rowId) => async (dispatch) => {
    const key = "updateOrderRowGoods";
    try {
      antdAsyncMessageLoading({ key });
      const res = await Axios.put(
        `/api/v1/orders/${orderId}/order_rows/${rowId}`,
        body,
      );
      if (res.data) {
        dispatch({
          type: UPDATE_ORDER_ROW_GOODS,
          payload: { items: res.data.data, total_price: res.data.total_price },
        });
      }
      antdAsyncMessageSuccess({ key });
      return { ok: true };
    } catch (err) {
      antdAsyncMessageError({ key });
      antdMessageError();
      if (err?.response?.data) {
        dispatch({
          type: GET_ERRORS,
          payload: err?.response?.data || {},
        });
      }
      return { ok: false };
    }
  };

export const setOrderRowDisabledAt = (body, orderId, rowId) => (dispatch) => {
  const key = "setOrderRowDisabledAt";
  return Axios.put(
    `/api/v1/orders/${orderId}/order_rows/${rowId}/set_disabled_at`,
    body,
  )
    .then((res) => {
      if (res.data) {
        dispatch({
          type: "ORDER_ROW_DISABLED_AT",
          payload: {
            id: orderId,
            order_rows: res.data.order_rows,
            shipments: res.data.shipments,
            order_histories: res.data?.order_histories,
          },
        });
      }
      return { ok: true, data: res.data };
    })
    .catch((err) => {
      antdAsyncMessageError({ key, text: err?.response?.data?.message });
    });
};
export const deleteOrderRowGoods = (orderId, rowId) => async (dispatch) => {
  const key = "deleteOrderRowGoods";
  try {
    if (!confirm("Are you sure want to delete?")) return false;
    antdAsyncMessageLoading({ key });
    const { data } = await Axios.delete(
      `/api/v1/orders/${orderId}/order_rows/${rowId}`,
    );

    if (data.ok) {
      dispatch({
        type: DELETE_ORDER_ROW_GOODS,
        payload: {
          orderId,
          rowId,
          order_rows: data.order_rows,
          total_price: data.total_price,
        },
      });
      antdAsyncMessageSuccess({ key });
      return true;
    }
    throw new Error("Err");
  } catch (err) {
    antdAsyncMessageError({ key });
    console.log({ err });
    if (err?.response?.data) {
      dispatch({
        type: GET_ERRORS,
        payload: err?.response?.data || {},
      });
    }
    return false;
  }
};

// Supplying kūrimas
export const postOrderRow =
  (PARAMS, orderId, orderRowId) => async (dispatch) => {
    const key = "postOrderRow";
    try {
      antdAsyncMessageLoading({ key });
      const res = await Axios.post(
        `/api/v1/orders/${orderId}/order_rows/${orderRowId}/supplyings`,
        PARAMS,
      );
      dispatch({
        type: UPDATE_ORDER_ROW_GOODS,
        payload: { items: res.data },
      });
      antdAsyncMessageSuccess({ key });
      return { success: true };
    } catch (err) {
      console.error("postOrderRow error: ", err);
      dispatch({
        type: GET_ERRORS,
        payload: err?.response?.data,
      });
      antdAsyncMessageError({ key, text: err?.response?.data?.message });
      return { success: false };
    }
  };

// Supplying ištrinimas
export const deleteOrderRow =
  (orderId, orderRowId, suppliersId) => async (dispatch) => {
    const key = "deleteOrderRow";
    try {
      if (!confirm("Are you sure want to delete?")) return false;
      antdAsyncMessageLoading({ key });
      const res = await Axios.delete(
        `/api/v1/orders/${orderId}/order_rows/${orderRowId}/supplyings/${suppliersId}`,
      );
      dispatch({
        type: UPDATE_ORDER_ROW_GOODS,
        payload: { items: res.data },
      });
      antdAsyncMessageSuccess({ key });
    } catch (err) {
      antdAsyncMessageError({ key });
      dispatch({
        type: GET_ERRORS,
        payload: err?.response?.data || {},
      });
    }
  };

export const updateOrderRowSupplying =
  (orderId, orderRowId, supplyingId, newDate, email) => async (dispatch) => {
    const key = "updateOrderRowSupplying";
    try {
      antdAsyncMessageLoading({ key });
      const res = await Axios.put(
        `/api/v1/orders/${orderId}/order_rows/${orderRowId}/supplyings/${supplyingId}`,
        { supplying: { date: newDate, email } },
      );
      dispatch({
        type: UPDATE_SUPPLYING,
        payload: { ...res.data, order_id: orderId },
      });
      antdAsyncMessageSuccess({ key });
      return true;
    } catch (err) {
      console.log("Error: ", err);
      dispatch({
        type: GET_ERRORS,
        payload: err?.response?.data,
      });
      antdAsyncMessageError({ key, text: err?.response?.data?.message });
    }
  };

export const createSmsItem = (orderId, variables) => (dispatch) => {
  return Axios.post(`/api/v1/orders/${orderId}/sms_sendings`, variables)
    .then((res) => {
      dispatch({
        type: CREATE_SMS_ITEM,
        payload: res.data,
      });
      return { success: true, sms_sending_id: res.data.id };
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err?.response?.data || {},
      });
      return { success: false };
    });
};

export const createOrderStatus = (orderId, variables) => (dispatch) => {
  return Axios.post(`/api/v1/orders/${orderId}/change_status`, variables)
    .then((res) => {
      dispatch({
        type: CREATE_ORDER_STATUS,
        payload: res.data,
      });
      return { success: true, data: res.data };
    })
    .catch((err) => {
      const errorMessage = err?.response?.data?.error || "An error occurred";
      dispatch({
        type: GET_ERRORS,
        payload: err?.response?.data || {},
      });
      return { success: false, error: errorMessage, data: null };
    });
};

// Nordrent variant of createOrderStatus: posts to the nordrent-namespaced
// change_status route. Response shape is identical (same inherited controller action).
export const createNordrentOrderStatus = (orderId, variables) => (dispatch) => {
  return Axios.post(
    `/api/v1/nordrent/orders/${orderId}/change_status`,
    variables,
  )
    .then((res) => {
      dispatch({
        type: CREATE_ORDER_STATUS,
        payload: res.data,
      });
      return { success: true, data: res.data };
    })
    .catch((err) => {
      const errorMessage = err?.response?.data?.error || "An error occurred";
      dispatch({
        type: GET_ERRORS,
        payload: err?.response?.data || {},
      });
      return { success: false, error: errorMessage, data: null };
    });
};

export const createOrder = (params) => async (dispatch) => {
  try {
    const { data } = await Axios.post("/api/v1/orders", params);
    successToast("order-s");
    dispatch({
      type: "NEW_ORDER",
      payload: data,
    });
    return { success: true, data };
  } catch (err) {
    unsuccessToast("order-e");
    if (err.response?.data) {
      return { success: false, errors: err?.response?.data || {} };
    }
    return err;
  }
};

export const updateSerialNumber = (id, itemId, body) => async (dispatch) => {
  const key = "updateSerialNumber";
  try {
    antdAsyncMessageLoading({ key });
    const res = await Axios.put(
      `/api/v1/orders/${id}/order_rows/${itemId}`,
      body,
    );
    dispatch({
      type: UPDATE_SERIAL_NUMBER,
      payload: res.data.data,
      payload2: id,
    });
    antdAsyncMessageSuccess({ key });
    return true;
  } catch (err) {
    dispatch({
      type: GET_ERRORS,
      payload: err?.response?.data || {},
    });
    antdAsyncMessageError({ key });
  }
};

export const createOrderCartRules = (order_id, body) => async (dispatch) => {
  const key = "createOrderCartRules";
  try {
    antdAsyncMessageLoading({ key });

    const { data } = await Axios.post(
      `/api/v1/orders/${order_id}/order_cart_rules`,
      {
        cart_rules: {
          title: body.title,
        },
        additional: body,
      },
    );

    dispatch({
      type: "POST_CART_RULES",
      payload: data.data,
      total_price: data.total_price,
    });
    antdAsyncMessageSuccess({ key });
  } catch (err) {
    console.error(err);
    antdAsyncMessageError({ key });

    return false;
  }
};

export const updateOrderCartRules = (body) => async (dispatch) => {
  const key = "updateOrderCartRules";
  try {
    antdAsyncMessageLoading({ key });

    const { data } = await Axios.put(
      `/api/v1/orders/${body.order_id}/order_cart_rules/${body.id}`,
      {
        cart_rules: {
          title: body.title,
        },
        additional: body,
      },
    );
    dispatch({
      type: UPDATE_CART_RULES,
      payload: data.data,
      total_price: data.total_price,
    });
    antdAsyncMessageSuccess({ key });

    return true;
  } catch (err) {
    console.error(err);
    antdAsyncMessageError({ key });

    return false;
  }
};

export const deleteOrderCartRules =
  (order_cart_rule_id, orderId) => async (dispatch) => {
    const key = "deleteOrderCartRules";
    try {
      antdAsyncMessageLoading({ key });
      const { data } = await Axios.delete(
        `/api/v1/orders/${orderId}/order_cart_rules/${order_cart_rule_id}`,
      );
      console.log("Res: deleteOrderCartRules", data);
      dispatch({
        type: "DELETE_CART_RULES",
        payload: {
          ...data,
          order_cart_rule_id,
          order_id: orderId,
        },
      });
      antdAsyncMessageSuccess({ key });
      return 1;
    } catch (err) {
      console.log("Err: deleteOrderCartRules", err);
      antdAsyncMessageError({ key });
      return 0;
    }
  };

export const orderShopsOptions = async () => {
  try {
    const { data } = await Axios.get("/api/v1/order_shops");
    if (data?.total > 0) {
      return data.shops;
    }
    return [];
  } catch (err) {
    console.log("Error: ", err);
  }
};

export const createHoomtask = (order_id, order_row_id) => async (dispatch) => {
  const key = "createHoomtask";
  try {
    antdAsyncMessageLoading({ key });
    const { data } = await Axios.post(
      `/api/v1/orders/${order_id}/order_rows/${order_row_id}/create_hoomtask`,
    );
    if (data.success) {
      antdAsyncMessageSuccess({ key });
      dispatch({
        type: UPDATE_ORDER_ROW_GOODS,
        payload: { items: data.data },
      });
      return { success: true };
    }
    throw new Error("Err");
  } catch (err) {
    antdAsyncMessageError({ key });
    return {
      success: false,
    };
  }
};

export const getOrderInitials = () => async (dispatch) => {
  try {
    await dispatch(setCountriesOptions());
    await dispatch(setOrderShopsOptions());
  } catch (err) {
    console.error("getOrderInitials: ", err);
    setTimeout(() => dispatch(getOrderInitials()), 1000);
  }
};

export const callGenerateShipmentXlsx = () => async (_, getState) => {
  try {
    const { params_filter } = getState().orders.settings;
    // console.log({ params_filter })
    antdAsyncMessageLoading({ key: "exportDocument" });

    const { data } = await Axios.get(
      `/api/v1/orders/generate_shipment_xlsx?${params_filter}`,
    );
    console.log({ data });
    if (!data?.success) {
      throw new Error(data?.message);
    }
    return 1;
  } catch (err) {
    console.log("ERROR: ", err);
    antdAsyncMessageError({ key: "exportDocument", text: err?.message });
    return 0;
  }
};

export const getOrdersShipmentsOver80Kg = () => async (dispatch) => {
  try {
    const response = await Axios.get("/api/v1/carriers/final");
    dispatch({
      type: GET_ORDERS_SHIPMENTS_OVER_80_KG,
      payload: response.data,
    });
  } catch (error) {
    console.error("Error fetching orders shipments over 80 kg:", error);
    antdMessageError(error?.response?.data?.message || "Error fetching data");
  }
};

export const updateSerialNumberState = (data) => (dispatch) => {
  dispatch({
    type: UPDATE_SERIAL_NUMBER_STATE,
    payload: data,
  });
};

export const setOrderLoading = () => {
  return {
    type: LOADING_ORDERS,
  };
};
export const setOrderShowLoading = () => {
  return {
    type: LOADING_ORDER,
  };
};

export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS,
  };
};
